const PRODUCTION_ENVIRONMENT_CONSTANTS = {
  provider: 'tradexa',
  baseUrl: 'https://api.hyperinvento.com/v1',
  mediaApiUrl: 'https://media.hyperinvento.com',
  backendBaseUrl: 'https://api.hyperinvento.com',
  version1: 'v1',
  version2: 'v2',
  searchApiUrl: 'https://search.hyperinvento.com',
  paytmGatewayUrl: 'https://securegw.paytm.in/merchantpgpui/checkoutjs/merchants/',
  ccAvenueGatewayUrl: {
    'staging': 'https://test.ccavenue.com/transaction/transaction.do?command=initiateTransaction',
    'production': 'https://secure.ccavenue.com/transaction/transaction.do?command=initiateTransaction'
  },
  adminClientId: 'D7GiCVhw134kUXOMpgoSpkyi5VXYwssGXykScPlc',
  // tslint:disable-next-line: max-line-length
  adminClientSecret: 'JZeF61sw6Xjw9oL3M34ENmulICnMnOcYJzwS6FHLZVxhGv7sesqkSYYxOZ8B8zXTRJAWKnfQiAyRyOmgNkDrswsiJ7WzFrt8Ecx9SF6Fpg7dDUEHVqqfgQyjlyZauFon',
  adminSalesChannel: 'f600d5',
  marketingUrl: 'https://marketing.hyperinvento.com',
  bflIV: '3a-8e64-01da6e30',
  warrantyApiUrl: 'https://warranty.hyperinvento.com',
  googleRecaptchaKey: '6LcadlIpAAAAALtGJ0UVoK_n8PfYFwqWrAMd75PQ',
  payu_url: "https://secure.payu.in/_payment",
  cashfree_mode: "production"
}

export const environment = {
  production: true,
  baseUrl: `${PRODUCTION_ENVIRONMENT_CONSTANTS.baseUrl}`,
  backendBaseUrl: `${PRODUCTION_ENVIRONMENT_CONSTANTS.backendBaseUrl}`,
  version1: `${PRODUCTION_ENVIRONMENT_CONSTANTS.version1}`,
  version2: `${PRODUCTION_ENVIRONMENT_CONSTANTS.version2}`,
  product_url: `${PRODUCTION_ENVIRONMENT_CONSTANTS.baseUrl}/consumer`,
  product_url_2: `${PRODUCTION_ENVIRONMENT_CONSTANTS.backendBaseUrl}/${PRODUCTION_ENVIRONMENT_CONSTANTS.version2}/consumer`,
  admin_url: `${PRODUCTION_ENVIRONMENT_CONSTANTS.baseUrl}`,
  provider: PRODUCTION_ENVIRONMENT_CONSTANTS.provider,
  paytmGatewayUrl: PRODUCTION_ENVIRONMENT_CONSTANTS.paytmGatewayUrl,
  ccAvenueGatewayUrl: PRODUCTION_ENVIRONMENT_CONSTANTS.ccAvenueGatewayUrl,
  mediaApiUrl: PRODUCTION_ENVIRONMENT_CONSTANTS.mediaApiUrl,
  adminClientId: PRODUCTION_ENVIRONMENT_CONSTANTS.adminClientId,
  adminClientSecret: PRODUCTION_ENVIRONMENT_CONSTANTS.adminClientSecret,
  adminSalesChannel: PRODUCTION_ENVIRONMENT_CONSTANTS.adminSalesChannel,
  marketingUrl: PRODUCTION_ENVIRONMENT_CONSTANTS.marketingUrl,
  bflIV: PRODUCTION_ENVIRONMENT_CONSTANTS.bflIV,
  searchApiUrl: PRODUCTION_ENVIRONMENT_CONSTANTS.searchApiUrl,
  warrantyApiUrl: PRODUCTION_ENVIRONMENT_CONSTANTS.warrantyApiUrl,
  googleRecaptchaKey: PRODUCTION_ENVIRONMENT_CONSTANTS.googleRecaptchaKey,
  payu_url: PRODUCTION_ENVIRONMENT_CONSTANTS.payu_url,
  cashfree_mode: PRODUCTION_ENVIRONMENT_CONSTANTS.cashfree_mode
};
